"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.asinhDependencies = void 0;

var _dependenciesTypedGenerated = require("./dependenciesTyped.generated.js");

var _factoriesAny = require("../../factoriesAny.js");

/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
var asinhDependencies = {
  typedDependencies: _dependenciesTypedGenerated.typedDependencies,
  createAsinh: _factoriesAny.createAsinh
};
exports.asinhDependencies = asinhDependencies;